// When review isn't required and there are no reviewers, no signer, and no peer
// review, there is nothing to review, so "Move to Review" routes straight to
// Processing (see startReviewWorkflow). reviewRequired is included so the label
// can't claim "no review" for a submission the user has marked as requiring it
// (that state is blocked by validation, but the button would still mislabel).
export function shouldAdvanceWithoutReview({
  reviewerCount,
  hasSigner,
  peerReviewRequired,
  reviewRequired,
}: {
  reviewerCount: number;
  hasSigner: boolean;
  peerReviewRequired?: boolean | null;
  reviewRequired?: boolean | null;
}) {
  return !reviewRequired && reviewerCount === 0 && !hasSigner && !peerReviewRequired;
}
